import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {SidebarItem, SidebarMenu} from './interface/sidebar-item';
import {AppMenuService} from "../../shared/services/menu/menu.service";
import {Router} from "@angular/router";

declare let $: any;

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent implements OnInit, AfterViewInit {

  @Input() root: boolean;
  @Input() item: SidebarItem;

  activeIndex: number;
  menus: SidebarMenu[];
  sidebarMenu: SidebarMenu[] = []
  loading = true;

  constructor(private readonly menuService: AppMenuService,  private readonly router: Router) {
    this.menuService.fetchMenu('sidebar');
  }

  ngOnInit() {
    this.menuService.getMenu().subscribe(response => {
      this.sidebarMenu = response;
      this.loading = false;
    });

    this.menuService.getPurgeMenus().subscribe(response => {
      const findMenu = response.find((menu: any) => {
        return menu.url === this.router.url;
      });
      return this.updateNestedParentItem(response, findMenu?.id);

    });
  }

  ngAfterViewInit(): void {
    $.getScript('assets/theme/w3crm/js/deznav-init.js');
  }

  handleItemClick(item: any) {
    if (item.items.length == 0) {
      switch (item.urlType) {
        case 'ROUTE':
          this.router.navigate([item.url]);
          break;
        case 'EXTERNAL':
          globalThis.location.href = item.url;
          break;
        case 'STATIC':
          globalThis.location.href = item.url;
          break;
        case 'FUNCTION':
          break;
      }
    }

    if (item.items.length > 0) {
      item.expanded = item.expanded === undefined ? true : !item.expanded;
      item.active = !item.active;
      item.ariaExpanded = !item.ariaExpanded;
      item.mmShow = !item.mmShow;
    }
    /*else {
      if (item.items.length > 0) {
        item.active = 'mm active';
        item.ariaExpanded = true;
        item.mmShow = 'mm-show';
      }
    }*/

  }


  updateNestedParentItem(array: any, id: string) {
    const findMenu = array.find((menu: any) => {
      return menu.id === id;
    });
    if (findMenu) {
      findMenu.expanded = true;
      if (findMenu.parentMenu) {
        this.updateNestedParentItem(array, findMenu.parentMenu.id);
      }
    }
  }


  protected readonly window = globalThis;
}
